import React, { FunctionComponent, useRef, useState } from "react";
import Slider, { Settings } from "react-slick";
import { ArrowButton } from "@/components/responsive/commun/arrowButton/ArrowButton";
import { ProductPackItem } from "@/models/scope/productSheet/ProductPackItem";
import { dispatchBundleItemHandleClick } from "@/animations/responsive/productPageTracking";

interface Props {
  items: ProductPackItem[];
  width: number;
  children?: JSX.Element;
  isMobile?: boolean;
  noDivider?: boolean;
  urlBundle?: string;
}

export const PackSlider: FunctionComponent<Props> = ({ items, width, children, isMobile, noDivider, urlBundle }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  let customSlider = useRef<Slider>(null);
  const itemsCount = items.length;
  const sliderOptions: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "ondemand",
    variableWidth: true,
    beforeChange: (currentSlide: number, nextSlide: number) => {
      nextSlide >= 0 && setActiveSlide(nextSlide);
      setIsDragging(true);
    },
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: () => setIsDragging(false),
  };

  const handleClick = (e: React.MouseEvent, title: string) => {
    if (isDragging) {
      e.preventDefault();
    } else {
      dispatchBundleItemHandleClick(title);
    }
  };

  return (
    <div className="slider">
      <ArrowButton
        onClick={() => customSlider.current?.slickPrev()}
        isDisable={activeSlide === 0}
        isRotated={true}
      />
      <ArrowButton
        onClick={() => customSlider.current?.slickNext()}
        isDisable={
          (itemsCount <= (isMobile ? 2 : 4)) || activeSlide >= (isMobile ? itemsCount - 1 : itemsCount - 4)
        }
        isRotated={false}
      />
      <Slider
        ref={(slider) => (customSlider = {
          ...customSlider,
          current: slider
        })}
        {...sliderOptions}
        //@ts-ignore
        style={{ width }}
      >
        {items.map((item, i) => {
          const {
            product: { images, title, id, sheetUrl },
          } = item;
          return (
              <a href={urlBundle || sheetUrl}>
                <div className="slice" key={id} onClick={(e) => handleClick(e, title)}>
                  <div className="pack-image">
                    <picture className="image">
                      <source srcSet={images.packItemImage} />
                      <img src={images.packItemImage} alt={title} />
                    </picture>
                    <p>{title}</p>
                  </div>
                  {i < items.length - 1 && (
                    <img className="plus" src={"/assets/images/responsive/icons/plus-bundle.svg"} alt="" />
                  )}
                </div>
              </a>
          );
        })}
      </Slider>
      {children}
      {!noDivider ? <hr /> : null}
    </div>
  );
};